import { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import CompanyService from '../../../services/CompanyService';
import { getIcon } from '../../../utils/IconHandler';

const AdminCredentialsModal = ({ open, onClose, company }) => {
  const [corePassword, setCorePassword] = useState('');
  const [credentials, setCredentials] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState('');

  useEffect(() => {
    if (!open) return;
    setCorePassword('');
    setCredentials(null);
    setLoading(false);
    setError('');
    setCopied('');
  }, [open, company?.id]);

  const handleReveal = async () => {
    if (!company?.id || !corePassword) {
      setError('Ingresá tu contraseña.');
      return;
    }

    setLoading(true);
    setError('');
    setCopied('');
    try {
      const data = await CompanyService.getAdminCredentials(company.id, corePassword);
      setCredentials(data);
      setCorePassword('');
    } catch (err) {
      const message = err?.response?.data?.error_message;
      setError(message === 'invalid_current_password'
        ? 'Tu contraseña no es correcta.'
        : 'No se pudieron obtener las credenciales.'
      );
    } finally {
      setLoading(false);
    }
  };

  const copyValue = async (label, value) => {
    try {
      await navigator.clipboard.writeText(value || '');
      setCopied(`${label} copiado.`);
    } catch {
      setCopied('');
    }
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Credenciales admin</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Box>
            <Typography variant="subtitle2">{company?.name || '-'}</Typography>
            <Typography variant="body2" color="text.secondary">{company?.domain || '-'}</Typography>
          </Box>

          {error ? <Alert severity="error">{error}</Alert> : null}
          {copied ? <Alert severity="success">{copied}</Alert> : null}

          {!credentials ? (
            <TextField
              label="Tu contraseña"
              type="password"
              value={corePassword}
              onChange={(e) => setCorePassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleReveal();
              }}
              fullWidth
              autoFocus
            />
          ) : (
            <Stack spacing={1.5}>
              <TextField
                label="Email"
                value={credentials.email || ''}
                InputProps={{ readOnly: true }}
                fullWidth
              />
              <TextField
                label="Password"
                value={credentials.password || ''}
                InputProps={{ readOnly: true }}
                fullWidth
              />
              <Stack direction="row" spacing={1}>
                <Button variant="outlined" startIcon={getIcon('document')} onClick={() => copyValue('Email', credentials.email)}>
                  Copiar email
                </Button>
                <Button variant="outlined" startIcon={getIcon('lock')} onClick={() => copyValue('Password', credentials.password)}>
                  Copiar password
                </Button>
              </Stack>
            </Stack>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cerrar</Button>
        {!credentials && (
          <Button variant="contained" onClick={handleReveal} disabled={loading}>
            Ver credenciales
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AdminCredentialsModal;
